import React from "react";
import styles from "../Dashboard.module.css";

const Support = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Support</main>
    </div>
  );
};

export default Support;
